import { ReactElement } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { ProtectedRouteProps } from "../interfaces/props";

export const ProtectedRoute = ({
    isAllowed,
    redirectPath = "/unauthorized",
    children,
}: ProtectedRouteProps): ReactElement => {
    if (!isAllowed) {
        return <Navigate to={redirectPath} replace />;
    }

    return children ? (children as ReactElement) : <Outlet />;
};
